var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-hero container-fluid"},[_c('div',{staticClass:"centered col-md-3"},[_c('h1',[_vm._v(_vm._s(_vm.site))]),_vm._v(" "),_c('br'),_c('span',[_vm._v("Strona główna / "+_vm._s(_vm.site))])])])}
var staticRenderFns = []

export { render, staticRenderFns }